import {
    AccountRoutes,
    BonusRoutes,
    ErrorRoutes,
    FreeToPlayRoutes,
    GamingRoutes,
    SportRoutes,
    UserJourneyRoutes,
    WikiRoutes,
} from '@superbet-group/web.types';

import { RouteIdentity } from '@app/router/types';

export const RouteName: RouteIdentity<string> = {
    App: {
        Home: SportRoutes.Landing,
        NotFound: ErrorRoutes.NotFound,
        Info: 'App.Info',
        NotAuthorized: ErrorRoutes.NotAuthorized,
        Wiki: WikiRoutes.Wiki,
        CatchAll: 'App.CatchAll',
        Shops: 'App.Shops',
        IdCardVerificationCaptive: 'App.IdCardVerificationCaptive',
        VerifyPhoneCaptive: 'App.VerifyPhoneCaptive',
        BrMigrationComplete: 'App.BrMigrationComplete',
    },
    Sport: {
        OfferEvent: 'Sport.OfferEvent',
        SportCompetitions: 'Sport.SportCompetitions',
        Competition: 'Sport.Competition',
        Filter: 'Sport.Filter',
        Search: 'Sport.Search',
        Favourites: 'Sport.Favourites',
        EventRedirect: 'Sport.EventRedirect',
        CategoryRedirect: 'Sport.CategoryRedirect',
        TournamentRedirect: 'Sport.TournamentRedirect',
        BetSlip: 'Sport.Betslip', // doesn't exist in a real route
        Category: 'Sport.Category',
        CategoryPerTime: 'Sport.CategoryPerTime',
        PrematchOffer: 'Sport.PrematchOffer',
        SuperAdvantage: 'Sport.SuperAdvantage',
        PriceBoost: 'Sport.PriceBoost',
        MultiEventBetBuilder: 'Sport.MultiEventBetBuilder',
        PopularBets: 'Sport.PopularBets',
        TopWinners: 'Sport.TopWinners',
        Social: 'Sport.Social',
    },
    Lottery: {
        Offer: GamingRoutes.LotteryLanding,
    },
    News: {
        Feed: 'News.Feed',
        Article: 'News.Article',
        Articles: 'News.Articles',
    },
    Free2Play: {
        SuperSpin: FreeToPlayRoutes.SuperSpin,
        SuperShot: FreeToPlayRoutes.SuperShot,
        CalendarGame: 'Free2Play.CalendarGame',
        FreeGamesInfo: 'Free2Play.FreeGamesInfo',
        SportCaller: 'Free2Play.SportCaller',
        FantasticDuels: 'Free2Play.FantasticDuels',
        SuperMillion: 'Free2Play.SuperMillion',
        TopManager: 'Free2Play.TopManager',
        BingoBash: 'Free2Play.BingoBash',
    },
    GrowthMarketing: {
        LandingIntro: 'GrowthMarketing.LandingIntro',
        PromotionsInfo: 'GrowthMarketing.BonusesPromotions',
        NewBettingSiteSerbia: 'GrowthMarketing.NewBettingSiteSerbia',
    },
    Account: {
        Register: 'Account.Register',
        Container: UserJourneyRoutes.AccountContainer,
        Deposit: UserJourneyRoutes.Deposit,
        History: 'Account.History',
        Profile: UserJourneyRoutes.Profile,
        Settings: 'Account.Settings',
        Withdrawal: 'Account.Withdrawal',
        DocumentUpload: 'Account.DocumentUpload',
        IdentityVerification: 'Account.IdentityVerification',
        IdentityVerificationUploadAdditional: 'Account.IdentityVerificationUploadAdditional',
        ResponsibleGaming: 'Account.ResponsibleGaming',
        DepositLimit: 'Account.ResponsibleGaming.DepositLimit',
        BettingLimit: 'Account.ResponsibleGaming.BettingLimit',
        LossLimit: 'Account.ResponsibleGaming.LossLimit',
        SessionLimit: 'Account.ResponsibleGaming.SessionLimit',
        SelfExclusion: 'Account.ResponsibleGaming.SelfExclusion',
        AccountClosure: 'Account.ResponsibleGaming.AccountClosure',
        TimeOut: 'Account.ResponsibleGaming.TimeOut',
        RealityCheck: 'Account.ResponsibleGaming.RealityCheck',
        MyMessages: 'Account.MyMessages',
        PasswordRecovery: 'Account.PasswordRecovery',
        ForgotPassword: 'Account.ForgotPassword',
        Recovery: 'Account.Recovery',
        Activate: 'Account.Activate',
        ContinueRegistration: 'Account.ContinueRegistration',
        ResendActivationEmail: 'Account.ResendActivationEmail',
        PaymentGatewayStatus: 'Account.PaymentGatewayStatus',
        ReferAFriend: 'Account.ReferAFriend',
        ChangePhone: 'Account.ChangePhone',
        HelpAndSupport: 'Account.HelpAndSupport',
        ChatPlaceholder: 'Account.ChatPlaceholder',
        MySocial: AccountRoutes.MySocial,
        EditMySocial: AccountRoutes.EditMySocial,
        BlockedUsers: AccountRoutes.BlockedUsers,
        MyAccount: 'Account.MyAccount',
        ChangePassword: 'Account.ChangePassword',
        SettingsBetslip: 'Account.SettingsBetslip',
        SwitchLanguage: 'Account.LanguageSwitcher',
        SwitchTheme: 'Account.SwitchTheme',
        LicencePreferences: 'Account.LicencePreferences',
        LoginHistory: 'Account.LoginHistory',
        AccountSecurity: 'Account.AccountSecurity',
    },
    BonusAndComms: {
        LpBonus: 'BonusAndComms.LpBonus',
        PromotionHub: BonusRoutes.PromotionHub,
        Notifications: 'BonusAndComms.Notifications',
        MarketingConsent: 'BonusAndComms.MarketingConsent',
    },
    Loyalty: {
        Supercoins: 'Loyalty.Supercoins',
    },
    Native: {
        AppsFooter: 'Native.AppsFooter',
        Wiki: 'Native.Wiki',
    },
};
